import React from "react";

const Footer = () => {
  return (
    <div className=" h-8 bottom-0 px-2 py-1 flex items-center justify-center w-full text-gray">
      <p>2023 © Guillermo Sotelo</p>
    </div>
  );
};

export default Footer;
